import * as types from '../actions/actionTypes';
import {beginAjaxCall, ajaxCallError} from '../actions/ajaxStatusActions';
import TaskApi from '../api/taskApi';


function getAll() {
    return function (dispatch) {
        return TaskApi.getTaskType().then(taskTypes => {
            dispatch(getAllSuccess(taskTypes));
        }).catch(error => {
            throw(error);
        });
    };
}

function getAllSuccess(taskTypes) {
    return {type: types.GET_ALL_TASK_TYPES_SUCCESS, taskTypes};
}

export {
    getAll
};


/** WEBPACK FOOTER **
 ** ./src/actions/taskTypesActions.js
 **/